// Emails a pending invitation through the invite-email Edge Function (0027). The function
// checks the administrator and the invitation with their own token, records the request
// and has Supabase Auth send the email from the organisation mailbox.
import { describeFailure } from '@/features/closeout/archive'
import { requireActiveClient } from '@/lib/session'

export type InviteEmailResult =
  | { ok: true; outcome: 'invitation_sent' | 'code_sent' }
  | { ok: false; message: string }

export async function emailInvitation(invitationId: string): Promise<InviteEmailResult> {
  try {
    const client = requireActiveClient()
    const { data, error } = await client.functions.invoke('invite-email', { body: { invitation_id: invitationId } })
    if (error) return { ok: false, message: await describeFailure(error) }
    const outcome = (data as { outcome?: string } | null)?.outcome
    if (outcome === 'invitation_sent' || outcome === 'code_sent') return { ok: true, outcome }
    return { ok: false, message: 'The mailer gave no answer.' }
  } catch (e) {
    return { ok: false, message: await describeFailure(e) }
  }
}
